import { Plugin as m } from "./index310.js";
class a {
  /**
  Create an input rule. The rule applies when the user typed
  something and the text directly in front of the cursor matches
  `match`, which should end with `$`.
  
  The `handler` can be a string, in which case the matched text, or
  the first matched group in the regexp, is replaced by that
  string.
  
  Or a it can be a function, which will be called with the match
  array produced by
  [`RegExp.exec`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec),
  as well as the start and end of the matched range, and which can
  return a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) that describes the
  rule's effect, or null to indicate the input was not handled.
  */
  constructor(s, e, t = {}) {
    this.match = s, this.match = s, this.handler = typeof e == "string" ? x(e) : e, this.undoable = t.undoable !== !1, this.inCode = t.inCode || !1, this.inCodeMark = t.inCodeMark !== !1;
  }
}
function x(l) {
  return function(s, e, t, r) {
    let n = l;
    if (e[1]) {
      let i = e[0].lastIndexOf(e[1]);
      n += e[0].slice(i + e[1].length), t += i;
      let o = t - r;
      o > 0 && (n = e[0].slice(i - o, i) + n, t = r);
    }
    return s.tr.insertText(n, t, r);
  };
}
const $ = 500;
function w({ rules: l }) {
  let s = new m({
    state: {
      init() {
        return null;
      },
      apply(e, t) {
        let r = e.getMeta(this);
        return r || (e.selectionSet || e.docChanged ? null : t);
      }
    },
    props: {
      handleTextInput(e, t, r, n) {
        return M(e, t, r, n, l, s);
      },
      handleDOMEvents: {
        compositionend: (e) => {
          setTimeout(() => {
            let { $cursor: t } = e.state.selection;
            t && M(e, t.pos, t.pos, "", l, s);
          });
        }
      }
    },
    isInputRules: !0
  });
  return s;
}
function M(l, s, e, t, r, n) {
  if (l.composing)
    return !1;
  let i = l.state, o = i.doc.resolve(s), u = o.parent.textBetween(Math.max(0, o.parentOffset - $), o.parentOffset, null, "￼") + t;
  for (let h = 0; h < r.length; h++) {
    let f = r[h];
    if (!f.inCodeMark && o.marks().some((d) => d.type.spec.code))
      continue;
    if (o.parent.type.spec.code) {
      if (!f.inCode)
        continue;
    } else if (f.inCode === "only")
      continue;
    let c = f.match.exec(u);
    if (!c || c[0].length < t.length)
      continue;
    let g = s - (c[0].length - t.length);
    if (!f.inCodeMark) {
      let d = !1;
      if (i.doc.nodesBetween(g, o.pos, (C) => {
        C.isInline && C.marks.some((k) => k.type.spec.code) && (d = !0);
      }), d)
        continue;
    }
    let p = f.handler(i, c, g, e);
    if (p)
      return f.undoable && p.setMeta(n, { transform: p, from: s, to: e, text: t }), l.dispatch(p), !0;
  }
  return !1;
}
const y = (l, s) => {
  let e = l.plugins;
  for (let t = 0; t < e.length; t++) {
    let r = e[t], n;
    if (r.spec.isInputRules && (n = r.getState(l))) {
      if (s) {
        let i = l.tr, o = n.transform;
        for (let u = o.steps.length - 1; u >= 0; u--)
          i.step(o.steps[u].invert(o.docs[u]));
        if (n.text) {
          let u = i.doc.resolve(n.from).marks();
          i.replaceWith(n.from, n.to, l.schema.text(n.text, u));
        } else
          i.delete(n.from, n.to);
        s(i);
      }
      return !0;
    }
  }
  return !1;
};
new a(/--$/, "—", { inCodeMark: !1 });
new a(/\.\.\.$/, "…", { inCodeMark: !1 });
new a(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(")$/, "“", { inCodeMark: !1 });
new a(/"$/, "”", { inCodeMark: !1 });
new a(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(')$/, "‘", { inCodeMark: !1 });
new a(/'$/, "’", { inCodeMark: !1 });
export {
  a as InputRule,
  w as inputRules,
  y as undoInputRule
};
